import AddCompany from './AddCompany'

export default AddCompany
